module.exports = __webpack_public_path__ + "c_static/img/找到公众号.2d8b328.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/找到公众号.png
// module id = oJJY
// module chunks = 33